import * as yup from 'yup'

import { pageNum, pageSize, requiredString, string } from '../yup/schemas.js'
import { companySchema } from '../company/general.schema.js'
import { RECRUITER_STATUSES, VALIDATION } from '../constants.js'
const { MESSAGES, REGEXP } = VALIDATION

export const recruiterSchema = yup.object({
  id: requiredString.uuid(),
  name: requiredString,
  phone:requiredString.phone(),
  status: requiredString.oneOf(Object.values(RECRUITER_STATUSES)),
  email: requiredString.email().toLowerCase(),
  initialCompanyDot: companySchema.get('dot'),
  initialCompanyName: companySchema.get('name'),
  password: requiredString.password()
}).objectRequired()

const createRecruiterSchema = recruiterSchema.pick([
  'name',
  'email',
  'phone',
  'initialCompanyDot',
  'initialCompanyName',
  'password'
])

const createInvitedRecruiterSchema = recruiterSchema.pick([
  'name',
  'phone',
  'password'
])

const patchRecruiterSchema = recruiterSchema.pick([
  'name',
  'email',
  'phone',
  'password'
]).allFieldsOptional()

const inviteRecruiterSchema = recruiterSchema.pick(['email'])
const getRecruiterParamsSchema = recruiterSchema.pick(['id'])
const getCompanyRecruiterParamsSchema = yup.object({
  id: recruiterSchema.get('id'),
  recruiterId: recruiterSchema.get('id')
}).objectRequired()
const getRecruiterListQueryParamsSchema = yup.object({
  pageNum,
  pageSize,
  recruiterNameSearch: string,
  status: recruiterSchema.get('status').optional()
}).objectRequired()

const createRecruiterSchemas = { front: createRecruiterSchema, back: createRecruiterSchema }
const createInvitedRecruiterSchemas = { front: createInvitedRecruiterSchema, back: createInvitedRecruiterSchema }
const getRecruiterParamsSchemas = { front: getRecruiterParamsSchema, back: getRecruiterParamsSchema }
const getCompanyRecruiterParamsSchemas = { front: getCompanyRecruiterParamsSchema, back: getCompanyRecruiterParamsSchema }
const getRecruiterListQueryParamsSchemas = { front: getRecruiterListQueryParamsSchema, back: getRecruiterListQueryParamsSchema }
const patchRecruiterSchemas = { front: patchRecruiterSchema, back: patchRecruiterSchema }
const inviteRecruiterSchemas = { front: inviteRecruiterSchema, back: inviteRecruiterSchema }

export default {
  createRecruiter: createRecruiterSchemas,
  createInvitedRecruiter: createInvitedRecruiterSchemas,
  patchRecruiter: patchRecruiterSchemas,
  inviteRecruiter: inviteRecruiterSchemas,
  getRecruiterParams: getRecruiterParamsSchemas,
  getRecruiterListQueryParams: getRecruiterListQueryParamsSchemas,
  getCompanyRecruiterParams: getCompanyRecruiterParamsSchemas
}
